/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */

import { useState } from 'react'

export const useNotificationState = () => {
  const [mutationSuccess, setMutationSuccess] = useState<string>()
  const [mutationError, setMutationError] = useState<string>()
  const [info, setInfo] = useState<string>()
  return {
    success: mutationSuccess,
    error: mutationError,
    info,
    setSuccess: setMutationSuccess,
    setError: setMutationError,
    setInfo,
  }
}
